import React, { useEffect, useCallback, useRef } from 'react';

import arrowUpIcon from '../../assets/arrowUp.svg';
import Image from '../Image';

import * as S from './style';

const BackToTop: React.FC = () => {
    const backToTopIconRef = useRef<HTMLAnchorElement | null>(null);

    const handleScroll = useCallback(() => {
        let scroll = window ? window.scrollY : 0;

        if (backToTopIconRef.current) {
            if (scroll < 20) {
                backToTopIconRef.current.style.opacity = '0';
                backToTopIconRef.current.style.visibility = 'hidden';
            } else {
                backToTopIconRef.current.style.opacity = '1';
                backToTopIconRef.current.style.visibility = 'visible';
            }
        }
    }, [])

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', handleScroll)
        }

        return () =>  window.addEventListener('scroll', () => {})
    }, [handleScroll])

    const onBackToTopClick = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    return (
        <S.BackToTopWrapper ref={backToTopIconRef} onClick={onBackToTopClick} href="#">
            <Image src={arrowUpIcon} alt="back to top icon" />
        </S.BackToTopWrapper>  
    )
}

export default BackToTop;